function configure(Highcharts) {
    //@ts-ignore
    Highcharts.wrap(Highcharts.seriesTypes.pie.prototype, "render", function (proceed) {
        if (!this.chart.subChartTitleElement) {
            this.chart.subChartTitleElement = {};
        }
        //Clear the title if added previously
        if (this.chart.subChartTitleElement && this.chart.subChartTitleElement[this.options.id]) {
            this.chart.subChartTitleElement[this.options.id].destroy();
        }
        proceed.call(this);
        if (this.center && this.options.title) {
            //first, add the title, at center or anywhere, we need the container width to center it
            this.chart.subChartTitleElement[this.options.id] = this.chart.renderer.text(this.options.title.text, this.center[0], this.center[1]);
            this.chart.subChartTitleElement[this.options.id].css(this.options.title.style);
            this.chart.subChartTitleElement[this.options.id].add();
            //Center the title using the container(Bounding Box = BBox) width
            var xCenter = this.chart.plotLeft + this.center[0] - (this.chart.subChartTitleElement[this.options.id].getBBox().width / 2), yCenter = this.chart.plotTop + this.center[1] - 0.6 * this.center[2];
            this.chart.subChartTitleElement[this.options.id].attr({ x: xCenter, y: yCenter });
        }
    });
}
export default configure;
